/*
 | -------------------------------------------------------------
 |  --> name: cookie-notice
 | -------------------------------------------------------------
 |
 |  Cookies design system component functionalities.
 |
*/

/* -------------------------------------------------------------
 | variables
 | -------------------------------------------------------------
 */

const cookieOpenButtons = document.querySelectorAll('[data-toggle-cookie]')

/* -------------------------------------------------------------
 | functions
 | -------------------------------------------------------------
 */

const openCookieNoticeClick = (event) => {
  event.preventDefault()

  document.getElementById('cookie-notice').style = 'display:block;'
  document.querySelector('.cookie-notice__title').focus()

  return false
}

/* -------------------------------------------------------------
 | execution
 | -------------------------------------------------------------
 */

cookieOpenButtons && cookieOpenButtons.forEach((button, i) => {
  button.addEventListener('click', openCookieNoticeClick)
})
